import { render, staticRenderFns } from "./ermInfo.vue?vue&type=template&id=220008e6&scoped=true"
import script from "./ermInfo.vue?vue&type=script&lang=ts"
export * from "./ermInfo.vue?vue&type=script&lang=ts"
import style0 from "./ermInfo.vue?vue&type=style&index=0&id=220008e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220008e6",
  null
  
)

export default component.exports